var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper"},[(_vm.isLoaded)?_c('div',{staticClass:"wrapper"},[(_vm.type === 'KYC')?_c('div',{},[_c('KYC')],1):_vm._e(),(_vm.type === 'FAQ')?_c('div',{},[_c('FAQ')],1):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }